parseTokenWwwD